const doc = [({"da":({"js":({"admin":({"plans":({"subscriptions":({"plan_subscriptions":"%{name} - medlemskaber"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;